export const iconFontAwesomeMedicalHealthSquareVirus = (
	<i className="fa-solid fa-square-virus"></i>
);
